import { VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_OTHER, VIEW_REQUEST_PROPOSAL_SEND_OFF_REASONS, } from '@/utils/constants/viewRequest/proposalSendOffReason';
/**
 * 提案辞退理由 取得
 */
export const getProposalRefuseReason = (proposalRefuseReason = null, proposalSendOffReasonComment = '') => {
    var _a;
    // コメントがある場合 コメントを返す
    if (proposalSendOffReasonComment) {
        return proposalSendOffReasonComment;
    }
    // コメントがない場合 カテゴリの文言を返す
    const label = ((_a = VIEW_REQUEST_PROPOSAL_SEND_OFF_REASONS.find(({ value }) => value === proposalRefuseReason)) === null || _a === void 0 ? void 0 : _a.label) || VIEW_REQUEST_PROPOSAL_SEND_OFF_REASON_OTHER.label;
    return `${label}により提案を辞退しました。`;
};
